export default {
  CALCULATE_MORTGAGE_DETAILS: 'calculate_mortgage_details',
  HOME_ADDRESS: 'home_address',
  MORTGAGE_FROM_TRANSUNION: 'mortgage_from_transunion',
  CURRENT_MORTGAGE_RATES: 'current_mortgage_rates'
};